import { InputAdornment, Typography, Dialog, DialogContent, IconButton, Box } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React, { useState, useEffect, useRef } from "react";
import { ReactComponent as NotepadIcon } from "../../images/notepadicon.svg";
import { ReactComponent as CheckedIcon } from "../../images/checkvector.svg";
import { ReactComponent as CrossIcon } from "../../images/crossvector.svg";
import WrongAnswer from "../wrongAnswer/WrongAnswer";
import { Select, MenuItem } from "@mui/material";
import { fetchExamLanguages } from "../../services/service";
import useQuestionsAndOptionsStyle from "./questionsAndOptionsStyle";
import DiclarationBox from "../wrongAnswer/CheckBoxDeclaration"
import CloseIcon from "@mui/icons-material/Close";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import ZoomOutIcon from "@mui/icons-material/ZoomOut";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import Draggable from "react-draggable";

function QuestionsAndOptions({ examResultData }) {
  const classes = useQuestionsAndOptionsStyle();
  const [selectLanguage, setSelectLanguage] = useState("english");
  const [languages, setLanguages] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedImg, setSelectedImg] = useState("");
  const [scale, setScale] = useState(1);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const draggableRef = useRef(null);

  const handleZoomIn = () => setScale((prev) => Math.min(prev + 0.5, 4));
  const handleZoomOut = () =>
    setScale((prev) => {
      const newScale = Math.max(prev - 0.5, 1);
      if (newScale === 1) setPosition({ x: 0, y: 0 });
      return newScale;
    });
  const handleResetZoom = () => {
    setScale(1);
    setPosition({ x: 0, y: 0 });
  };

  const handleImageClick = (e) => {
    if (e.target.tagName === "IMG") {
      setSelectedImg(e.target.src);
      setOpen(true);
    }
  };
  const handlefetchExamLanguages = async (examId) => {
    try {
      const languageData = await fetchExamLanguages(examId);
      if (languageData && languageData.length > 0) {
        setLanguages(
          languageData.map((lang) => ({
            label:
              lang.language.charAt(0).toUpperCase() + lang.language.slice(1),
            value: lang.language,
          })),
        );
      }
    } catch (error) {
      console.error("Error fetching languages:", error);
    }
  };

  useEffect(() => {
    const examId = sessionStorage.getItem("examId");
    handlefetchExamLanguages(examId);
  }, []);

  const handleChangeLanguage = (event) => {
    setSelectLanguage(event.target.value);
  };

  const getAlphabetLetter = (index) => {
    return String.fromCharCode(65 + index);
  };

  const isSame = (xs, ys, index) => {
    if (xs.sort().join(",") === ys.sort().join(",")) {
      return true;
    }
    return false;
  };

  const isAnswerInRange = (answer, rangeStr) => {
    if (!answer || !rangeStr) return false;
    const num = parseFloat(answer);
    if (isNaN(num)) return false;
    const match = rangeStr.match(/^(-?\d+\.?\d*)\s*-\s*(-?\d+\.?\d*)$/);
    if (!match) return false;
    const min = parseFloat(match[1]);
    const max = parseFloat(match[2]);
    if (isNaN(min) || isNaN(max)) return false;
    return num >= min && num <= max;
  };

  return (
    <div className={classes.container}>
      {/* Language selection dropdown */}
      <div style={{ textAlign: "center", margin: "1rem" }}>
        {/* <Select
  className={classes.langoption}
  variant="outlined"
  onChange={handleChangeLanguage}
  value={selectLanguage}
  displayEmpty
  inputProps={{ "aria-label": "Without label" }}
>
  <MenuItem disabled value="">
    <em>Select language</em>
  </MenuItem>
  {languages.map((lang) => (
    <MenuItem key={lang.value} value={lang.value}>{lang.label}</MenuItem>
  ))}
</Select> */}
      </div>

      {/* Custom style for question images */}
      <style jsx>{`
        span img {
          cursor: zoom-in;
          width: 700px;
          height: auto;
        }
      `}</style>

      {examResultData.result.map((item, index) => {
        const correctOptionIds = item.correct_option_ids ?? [];
        const selectedOptionIds = item.selected_option_ids ?? [];

        const correctOptionMatch = item.correct_match_matrix ?? {};
        const selectedOptionMatch = item.match_matrix ?? {};
        const isMatch = item.question_type.includes("Match");

        const getMatchResult = (correct = {}, selected = {}) => {
          if (!correct || typeof correct !== "object") return [];

          return Object.keys(correct).map((key) => {
            const correctValues = Array.isArray(correct[key])
              ? correct[key]
              : [];

            const selectedValues = Array.isArray(selected?.[key])
              ? selected[key]
              : [];

            const isCorrect =
              correctValues.length === selectedValues.length &&
              correctValues.every((v) => selectedValues.includes(v));

            return {
              question: key, // A, B, C, D
              correct: correctValues, // ["P", "Q"]
              selected:
                selectedValues.length > 1
                  ? selectedValues.join(", ")
                  : (selectedValues[0] ?? ""),
              isCorrect, // true / false
              _selectedArray: selectedValues, // internal use
            };
          });
        };

        // ✅ Get results
        const matchResults = getMatchResult(
          correctOptionMatch,
          selectedOptionMatch,
        );

        // ✅ Check user selected something
        const hasSelectedSomething = matchResults.some(
          (m) => m._selectedArray.length > 0,
        );

        // ✅ Count correct answers
        const correctCount = matchResults.filter((m) => m.isCorrect).length;
        const totalCount = matchResults.length;


        // ✅ Check if all correct
        const isAllCorrect = totalCount > 0 && correctCount === totalCount;

        // ✅ Final Message
        const getFinalMessage = () => {
          if (!hasSelectedSomething) {
            return "Oops! You Have Not Selected Any Option For This Question.";
          }

          // All correct
          if (correctCount === totalCount) {
            return "Your Answer is Correct!";
          }

          // Some correct some wrong
          if (correctCount > 0) {
            return "Your Answer Is Partially Correct.";
          }

          // All wrong
          return "Oops! Your Answer Is Wrong.";
        };

        // ✅ Function for UI usage
        const matchResult = () => {
          if (!correctOptionMatch || !selectedOptionMatch) return [];
          return getMatchResult(correctOptionMatch, selectedOptionMatch);
        };

        let isNoOptionSelected =
          selectedOptionIds.length === 0 && item.answer === "";
        const isFillUp = item.question_type === "Fill In The Blanks" || item.question_type === "Range";
        const isRange = item.question_type === "Range";
        let correctFillUpOption = null;
        if (isFillUp) {
          correctFillUpOption =
            item.options.filter((opt) => opt.correct_option)[0] ?? null;
        }
        if (correctFillUpOption) {
          correctFillUpOption = correctFillUpOption?.solution_en;
        }
        return (
          <div key={item.id} className={classes.containerInner}>
            <div className={classes.heading}>
              <NotepadIcon className={classes.notepadIcon} />
              <Typography variant="h3">
                Question {index + 1} / {examResultData.result.length}
              </Typography>
            </div>

            <div className={classes.quizContainer}>
              <div className={classes.question} onClick={handleImageClick}>
                <Typography
                  variant="caption"
                  component="div"
                  dangerouslySetInnerHTML={{
                    __html:
                      selectLanguage === "english"
                        ? item.question_en
                        : item.question_hi,
                  }}
                />
              </div>

              {isMatch && (
                <>
                  <div className={classes.optionsContainer}>
                    {matchResult().map((option) => {
                      const success = option.isCorrect;

                      return (
                        <div
                          key={option.question}
                          className={`${classes.options} ${success ? classes.rightOption : classes.wrongOption
                            }`}
                        >
                          {/* Question key */}
                          <InputAdornment position="start">
                            <div className={classes.squareBox}>
                              {option.question}
                            </div>
                          </InputAdornment>

                          {/* Correct vs Selected */}
                          <Typography variant="h6">
                            Correct:{" "}
                            <strong>{option.correct.join(", ")}</strong>
                            {" | "}
                            Selected:{" "}
                            <strong
                              style={{
                                color: success ? "green" : "red",
                              }}
                            >
                              {option.selected ?? "—"}
                            </strong>
                          </Typography>

                          {/* Icon */}
                          <InputAdornment position="end">
                            {success ? (
                              <CheckedIcon className={classes.checkIcon} />
                            ) : (
                              <CrossIcon className={classes.crossIcon} />
                            )}
                          </InputAdornment>
                        </div>
                      );
                    })}
                  </div>
                  <Typography
                    variant="h6"
                    style={{
                      color: isAllCorrect ? "green" : "red",
                      marginBottom: "8px",
                    }}
                  >
                    {!isAllCorrect && (
                      <CrossIcon
                        className={classes.crossIcon}
                        style={{ borderRadius: "100%", marginRight: 10 }}
                      />
                    )}
                    {getFinalMessage()}
                  </Typography>

                  <Typography variant="body1" className={classes.solutionText}>
                    <span className={classes.spanText}>Answer:</span> The
                    correct option is{" "}
                    {matchResult().length > 0 &&
                      matchResult().map((item) => (
                        <div key={item.question}>
                          <strong>{item.question}</strong> → Correct:{" "}
                          {item.correct.join(", ")}
                        </div>
                      ))}
                  </Typography>
                </>
              )}

              {(isFillUp && item.answer) || (!isFillUp && !isMatch) ? (
                <div className={classes.optionsContainer}>
                  {item.options.map((option, optIndex) => {
                    if (!isFillUp || (isFillUp && option.correct_option)) {
                      let success = null;
                      if (option.correct_option) {
                        success = true;
                        if (isRange) {
                          success = isAnswerInRange(item.answer, option.solution_en);
                        } else if (isFillUp && option.solution_en !== item.answer) {
                          success = false;
                        }
                      } else if (selectedOptionIds.includes(option.id)) {
                        success = false;
                      } else if (isFillUp) {
                        success = false;
                      }

                      return (
                        <div
                          key={option.id}
                          onClick={handleImageClick}
                          className={`${classes.options} ${success === true
                            ? classes.rightOption
                            : success === false
                              ? classes.wrongOption
                              : ""
                            }`}
                        >
                          {isFillUp ? (
                            <></>
                          ) : (
                            <InputAdornment position="start">
                              <div className={`${classes.squareBox}`}>
                                {isFillUp ? "A" : getAlphabetLetter(optIndex)}
                              </div>
                            </InputAdornment>
                          )}
                          <Typography
                            variant="h6"
                            component="div"
                            dangerouslySetInnerHTML={{
                              __html: isFillUp
                                ? item.answer
                                : selectLanguage === "english"
                                  ? option.option_en
                                  : option.option_hi,
                            }}
                          />
                          <InputAdornment position="end">
                            {(isRange
                              ? isAnswerInRange(item.answer, option.solution_en)
                              : isFillUp
                                ? option.solution_en === item.answer
                                : option.correct_option) && (
                                <CheckedIcon className={classes.checkIcon} />
                              )}
                            {((selectedOptionIds &&
                              selectedOptionIds.includes(option.id) &&
                              !option.correct_option) ||
                              (isRange
                                ? !isAnswerInRange(item.answer, option.solution_en)
                                : isFillUp &&
                                option.solution_en !== item.answer)) && (
                                <CrossIcon className={classes.crossIcon} />
                              )}
                          </InputAdornment>
                        </div>
                      );
                    } else {
                      return <></>;
                    }
                  })}
                </div>
              ) : (
                <></>
              )}

              {isFillUp &&
                (isRange
                  ? !isAnswerInRange(item.answer, correctFillUpOption)
                  : correctFillUpOption !== item.answer) && (
                  <WrongAnswer
                    correctOptionIds={correctOptionIds}
                    options={item.options}
                    selectLanguage={selectLanguage}
                    isNoOptionSelected={isNoOptionSelected}
                    isFillInTheBlank={isFillUp}
                    answer={item?.answer ?? ""}
                    correctFillUpOption={correctFillUpOption}
                    selectedOptionIds={selectedOptionIds}
                    questionType={item.question_type}
                    correctOptionMatch={correctOptionMatch}
                    selectedOptionMatch={selectedOptionMatch}
                  />
                )}

              {!isFillUp &&
                !isMatch &&
                (isNoOptionSelected ||
                  !isSame(selectedOptionIds, correctOptionIds)) && (
                  <WrongAnswer
                    correctOptionIds={correctOptionIds}
                    options={item.options}
                    selectLanguage={selectLanguage}
                    isNoOptionSelected={isNoOptionSelected}
                    isFillInTheBlank={isFillUp}
                    answer={item?.answer ?? ""}
                    correctFillUpOption={correctFillUpOption}
                    selectedOptionIds={selectedOptionIds}
                    questionType={item.question_type}
                  />
                )}

              {((isSame(selectedOptionIds, correctOptionIds, index + 1) &&
                selectedOptionIds.length > 0) ||
                (isRange
                  ? isAnswerInRange(item.answer, correctFillUpOption)
                  : correctFillUpOption === item.answer)) && (
                  <Typography variant="h6" style={{ color: "green" }}>
                    Your Answer is Correct!
                    {isRange && correctFillUpOption && (
                      <span style={{ fontSize: "0.85em", marginLeft: 8 }}>
                        (Correct Range: {correctFillUpOption})
                      </span>
                    )}
                  </Typography>
                )}
            </div>
          </div>
        );
      })}

      <DiclarationBox />

      {/* Premium Image Preview Modal */}
      <Dialog
        open={open}
        onClose={() => {
          setOpen(false);
          handleResetZoom();
        }}
        maxWidth={false}
        sx={{
          "& .MuiDialog-paper": {
            width: { xs: "98vw", sm: "90vw", md: "80vw" },
            height: { xs: "70vh", sm: "80vh", md: "80vh" },
            maxHeight: "95vh",
            margin: { xs: "4px", md: "16px" },
            borderRadius: { xs: "12px", md: "8px" },
            // backgroundColor: "#1a1a1a",
            backgroundColor: "#fff",
            boxShadow: "0 24px 48px rgba(0,0,0,0.4)",
            overflow: "hidden",
          },
        }}
      >
        <IconButton
          onClick={() => {
            setOpen(false);
            handleResetZoom();
          }}
          sx={{
            position: "absolute",
            top: 12,
            right: 12,
            zIndex: 1300,
            // color: "white",
            color: "black",
            // backgroundColor: "rgba(255,255,255,0.1)",
            backgroundColor: "rgba(0,0,0,0.05)",
            backdropFilter: "blur(4px)",
            "&:hover": { 
              // backgroundColor: "rgba(255,255,255,0.2)" 
              backgroundColor: "rgba(0,0,0,0.1)"
            },
            padding: "8px",
          }}
        >
          <CloseIcon fontSize="medium" />
        </IconButton>

        <DialogContent
          sx={{
            p: 0,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            // backgroundColor: "#111",
            backgroundColor: "#fff",
            overflow: "hidden",
            position: "relative",
            height: "100%",
            width: "100%",
          }}
        >
          <Draggable
            nodeRef={draggableRef}
            disabled={scale === 1}
            position={position}
            onStop={(e, data) => setPosition({ x: data.x, y: data.y })}
          >
            <Box
              ref={draggableRef}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                cursor: scale > 1 ? "grab" : "zoom-in",
                "&:active": { cursor: scale > 1 ? "grabbing" : "zoom-in" },
                transition: scale === 1 ? "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)" : "none",
              }}
            >
              <img
                src={selectedImg}
                alt="Preview"
                style={{
                  transform: `scale(${scale})`,
                  transition: scale === 1 ? "transform 0.3s ease" : "none",
                  maxWidth: "90%",
                  maxHeight: "90%",
                  objectFit: "contain",
                  userSelect: "none",
                  pointerEvents: "none",
                  // backgroundColor: "#fff",
                  // padding: "16px",
                  // borderRadius: "8px",
                }}
              />
            </Box>
          </Draggable>

          {/* Premium Zoom Controls ToolBar */}
          <Box
            sx={{
              position: "absolute",
              bottom: 24,
              left: "50%",
              transform: "translateX(-50%)",
              display: "flex",
              alignItems: "center",
              gap: 0.5,
              // backgroundColor: "rgba(255,255,255,0.1)",
              backgroundColor: "rgba(0,0,0,0.8)",
              backdropFilter: "blur(12px)",
              padding: "6px 12px",
              borderRadius: "30px",
              // border: "1px solid rgba(255,255,255,0.1)",
              border: "1px solid rgba(0,0,0,0.1)",
              zIndex: 1200,
              boxShadow: "0 8px 32px rgba(0,0,0,0.3)",
            }}
          >
            <IconButton
              onClick={handleZoomOut}
              sx={{ color: "white", "&:disabled": { color: "rgba(255,255,255,0.3)" } }}
              disabled={scale <= 1}
              size="small"
            >
              <ZoomOutIcon />
            </IconButton>

            <Typography
              variant="caption"
              sx={{
                color: "white",
                minWidth: "45px",
                textAlign: "center",
                fontWeight: 600,
                fontSize: "0.75rem",
                letterSpacing: "0.5px"
              }}
            >
              {Math.round(scale * 100)}%
            </Typography>

            <IconButton
              onClick={handleZoomIn}
              sx={{ color: "white", "&:disabled": { color: "rgba(255,255,255,0.3)" } }}
              disabled={scale >= 4}
              size="small"
            >
              <ZoomInIcon />
            </IconButton>

            <Box sx={{ width: "1px", height: "16px", backgroundColor: "rgba(255,255,255,0.2)", mx: 1 }} />

            <IconButton
              onClick={handleResetZoom}
              sx={{ color: "white" }}
              size="small"
              title="Reset Zoom"
            >
              <RestartAltIcon />
            </IconButton>
          </Box>
        </DialogContent>
      </Dialog>

    </div>
  );
}

export default QuestionsAndOptions;
